const ItemCategories = Object.freeze({
    INGREDIENTI: "Ingredienti",
	PIZZE: "Pizze",
    BIBITE: "Bibite",
    DOLCI: "Dolci"
})

export default ItemCategories
